import ToolAlignment from './ToolAlignment';
import { type Alignment } from '../../../types/aha-editor';

class ToolAlignCenter extends ToolAlignment {
  static toolName = 'Center align';
  static iconClass = 'fa-regular fa-align-center';
  static alignment: Alignment = 'center';
}

export default ToolAlignCenter;
